/**
 * Activity the server relays from the user's other copies of the app (DataHub "UserActivity").
 * dashboardSetup owns the hub connection and emits here; inactivitySetup subscribes. Kept apart from
 * both so neither has to import the other.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Subscribes to relayed activity. Returns the unsubscribe function. */
export function onRemoteActivity(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function emitRemoteActivity(): void {
    listeners.forEach((listener) => listener());
}
